export const HEAD_OFFICE_CAMPUS_ID = 1;

export function filterItemsWithQty(items) {
  return (Array.isArray(items) ? items : []).filter(
    (row) => Number(row.qty) > 0
  );
}

export function normalizeFormItem(row, getCategoryName) {
  const categoryID = row.categoryID || row.categoryId || row.catID || 0;
  return {
    id: row.id || 0,
    categoryID: Number(categoryID),
    categoryName:
      row.categoryName ||
      row.meta_category ||
      row.category ||
      (getCategoryName ? getCategoryName(categoryID) : "—"),
    particular: row.particular || "",
    subCategory:
      row.subCategory || row.sub_category || row.itemName || row.item || "",
    qty: Number(
      row.qty != null
        ? row.qty
        : row.requiredQty != null
          ? row.requiredQty
          : 0
    ),
  };
}

export function buildPayloadItems(formItems) {
  return filterItemsWithQty(formItems).map((row) => {
    const item = {
      categoryID: Number(row.categoryID),
      particular: String(row.particular || "").trim(),
      subCategory: String(row.subCategory || "").trim(),
      qty: Number(row.qty),
    };
    if (row.id) item.id = row.id;
    return item;
  });
}

export function mapApiItems(items, getCategoryName) {
  return (Array.isArray(items) ? items : []).map((row) =>
    normalizeFormItem(row, getCategoryName)
  );
}

export function parseBookListSelected(
  response,
  { fallbackItem = {}, getCategoryName, getClassName, getSectionName } = {}
) {
  let payload = response;
  if (
    response &&
    response.data &&
    typeof response.data === "object" &&
    !Array.isArray(response.data)
  ) {
    payload = response.data;
  }

  const header = payload.header || payload.record || payload;
  const rawItems =
    payload.items ||
    header.items ||
    payload.bookListItems ||
    header.bookListItems ||
    [];

  const classID = header.classID ?? header.classId ?? fallbackItem.classID;
  const sectionID =
    header.sectionID ?? header.sectionId ?? fallbackItem.sectionID;

  return {
    header: {
      id: header.id || fallbackItem.id || 0,
      classID,
      sectionID,
      className:
        header.className ||
        header.meta_class ||
        header.clsName ||
        fallbackItem.className ||
        (getClassName ? getClassName(classID) : "—"),
      sectionName:
        header.sectionName ||
        header.meta_section ||
        header.secName ||
        fallbackItem.sectionName ||
        (getSectionName ? getSectionName(classID, sectionID ?? 0) : "—"),
    },
    items: mapApiItems(rawItems, getCategoryName),
  };
}

export function buildItemSections(
  items,
  categoryOptions,
  getCategoryName,
  { activeOnly = false } = {}
) {
  const list = Array.isArray(items) ? items : [];
  const categoryOrder = (categoryOptions || []).map((cat) => Number(cat.id));
  const groups = new Map();

  list.forEach((item, globalIndex) => {
    if (activeOnly && !(Number(item.qty) > 0)) return;

    const categoryID = Number(item.categoryID);
    if (!groups.has(categoryID)) {
      groups.set(categoryID, {
        categoryID,
        categoryName:
          item.categoryName ||
          (getCategoryName ? getCategoryName(categoryID) : "—"),
        items: [],
        sectionQty: 0,
      });
    }

    const group = groups.get(categoryID);
    group.items.push({
      ...item,
      _globalIndex: globalIndex,
    });
    group.sectionQty += Number(item.qty) || 0;
  });

  const orderedIds = [
    ...categoryOrder.filter((id) => groups.has(id)),
    ...[...groups.keys()].filter((id) => !categoryOrder.includes(id)),
  ];

  return orderedIds.map((id) => groups.get(id)).filter(Boolean);
}
